import React, { useState } from 'react';
import DropdownMenu from './DropdownMenu';
import FilterSubmissionsItem from './FilterSubmissionsItem';

const conversation_filters_row_1 = [
  { label: 'Confirmed', value: 'CONFIRMED' },
  { label: 'Rescheduled', value: 'RESCHEDULED' },
  { label: 'Canceled', value: 'CANCELLED' },
  { label: 'In progress', value: 'IN_PROGRESS' },
  { label: 'Opted out', value: 'OPTED_OUT' },
  { label: 'Unconfirmed', value: 'UNCONFIRMED' },
  { label: 'Reminders unavailable', value: 'TST' },
];
const FilterConversations = ({
  onChange,
  filter,
  clearFilter,
  applyFilter,
  selectedOption,
  tempSelectedStatus,
  handleFilterSelection,
  options,
  ...rest
}) => {
  return (
    <DropdownMenu {...rest}>
      <div className="options-group">
        <div className="sources">
          <div className="title">CAMPAIGN STATUS</div>
          <div className="multi-row-filter">
            <div className="filter-row" style={{ padding: '10px' }}>
              {options.map((item, index) => {
                return (
                  <FilterSubmissionsItem
                    label={item.label}
                    key={index}
                    value={item.value}
                    onClick={handleFilterSelection}
                    type="BUTTON"
                    className={''}
                    iconclassName={'fas fa-flag'}
                    selectedOption={tempSelectedStatus}
                    filter={tempSelectedStatus}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div className="actions">
        <button
          className="btn btn--primary btn--lg apply"
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            applyFilter();
          }}
        >
          APPLY
          {tempSelectedStatus.length > 0 && <span>({tempSelectedStatus.length})</span>}
        </button>
        <div
          className="clear"
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            clearFilter();
          }}
        >
          clear selection
        </div>
      </div>
    </DropdownMenu>
  );
};

export default FilterConversations;
